/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import {
  Box,
  Grid,
  Menu,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Button,
  Divider,
  Typography
} from '@mui/material';
import {
  KeyboardArrowDown as ChevronDownIcon
} from '@mui/icons-material';
import { useSamarthDashboardContext } from '../../../../../utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import { useKpiData } from '../../../../../utils/samarth-dashboard-context/hooks/useKpiData';
import { MapFilters } from '../../../../../utils/samarth-dashboard-context/constants/samarth-dashboard-constants';
import styles from './dashboard-grid.module.css';
import MAIWidget from '../widgets/maiWidgets/mai-widget';
import FilterButtons from '../FilterButtons';
import MapChart from '../india-map/IndiaChroloropethMap';
import ExternalDisruption from '../external-disruption';
import FGCoverageWidget from '../widgets/fgCoverageWidget/fg-coverage-widget';
import SalesIndexWidget from '../widgets/salesIndexWidget/salesIndexWidget';
import MSTNWidget from '../widgets/mstnWidget/mstn-widget';
import Day0Widget from '../widgets/day0Widget/Day0-Widget';
import DRWidget from '../widgets/DrWidget/Dr-Widget';
import OSAWidget from '../widgets/osaWidget/osa-widget';
import ManpowerIndexWidget from '../widgets/manPowerIndexWidget/manpower-index-widget';
import DispatchComplianceWidget from '../widgets/dispatchComplianceWidget/dispatch-compliance-widget';
import ProjectedORWidget from '../widgets/projectedWeeklyOrWidget/projectOrWidget';

const indianStatesAndUTs = [
  "Andhra Pradesh",
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Andaman and Nicobar Islands',
  'Chandigarh',
  'Delhi',
  'Jammu and Kashmir',
  'Ladakh',
  'Lakshadweep',
  'Puducherry',
];

const regions = ['North', 'South', 'East', 'West'];

export default function DashboardGrid() {
  const { fetchInitialGlobalFilter, updateMapFilter } = useSamarthDashboardContext();
  const { filters } = useKpiData();
  const [anchorEls, setAnchorEls] = React.useState({});

  useEffect(() => {
    fetchInitialGlobalFilter(filters);
  }, []);

  const handleMenuOpen = (event, menuKey) => {
    setAnchorEls(prev => ({ ...prev, [menuKey]: event.currentTarget }));
  };

  const handleMenuClose = (menuKey) => {
    setAnchorEls(prev => ({ ...prev, [menuKey]: null }));
  };

  const toggleFilter = (key, value) => {
    if (filters.mapfilters[key] === value) {
      updateMapFilter(key, null);
    } else {
      updateMapFilter(key, value);
    }
  };

  const toggleRegion = (key, region) => {
    if (filters.mapfilters[key]?.includes(region)) {
      updateMapFilter(
        key,
        filters.mapfilters[key]?.filter((r) => r !== region)
      );
    } else {
      updateMapFilter(
        key,
        filters.mapfilters[key] ? [...filters.mapfilters[key], region] : [region]
      );
    }
  };

  const isRegionChecked = (key, region) => {
    return filters.mapfilters[key]?.includes(region) || false;
  };

  const isFilterActive = (key, value) => {
    return filters.mapfilters[key] === value;
  };

  return (
    <Grid container spacing={2} className={styles.gridContainer}>
      {/* Left Column */}
      <Grid item xs={12} md={3} className={styles.leftColumn}>
        <Grid container direction="column" spacing={1} style={{
          maxWidth: "100%",
          maxHeight: "100%"
        }}>
          <Grid item className={styles.gridItem}>
            <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
              <MAIWidget />
            </Box>
          </Grid>
          <Grid item className={styles.gridItem}>
            <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
              <FGCoverageWidget />
            </Box>
          </Grid>
          <Grid item className={styles.gridItem}>
            <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
              <SalesIndexWidget /> 
            </Box>
          </Grid>
          <Grid item className={styles.gridItem}>
            <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
               <MSTNWidget />
            </Box>
          </Grid>
        </Grid>
      </Grid>

      {/* Middle Column*/}
      <Grid item xs={12} md={6} className={styles.middleColumn}>
        <Grid container direction="column" spacing={1}>
          <Grid item className={styles.gridItem}>
            <FilterButtons showWeeks /> 
          </Grid>
          
          <Grid item style={{
            width: "inherit"
          }}>
            <Box className={`${styles.cardStyle} ${styles.mapCardBackground}`}>
              <Box className={styles.mapHeader}>
                <Box className={styles.mapFilters}>
                  <Button
                    onClick={(e) => handleMenuOpen(e, 'region')}
                    className={styles.filterTrigger}
                    endIcon={<ChevronDownIcon className={styles.chevronIcon} />}
                  >
                    Region
                  </Button>
                  <Menu
                    anchorEl={anchorEls.region}
                    open={Boolean(anchorEls.region)}
                    onClose={() => handleMenuClose('region')}
                    className={styles.dropdownMenu}
                    PaperProps={{ className: styles.menuPaper }}
                  >
                    {regions.map((region) => (
                      <MenuItem key={region} className={styles.menuItem}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isRegionChecked(MapFilters.REGION, region)}
                              onChange={() => toggleRegion(MapFilters.REGION, region)}
                              size="small"
                            />
                          }
                          label={region}
                          className={styles.checkboxLabel}
                        />
                      </MenuItem>
                    ))}
                  </Menu>

                  <Button
                    onClick={(e) => handleMenuOpen(e, 'state')}
                    className={styles.filterTrigger}
                    endIcon={<ChevronDownIcon className={styles.chevronIcon} />}
                  >
                    State
                  </Button>
                  <Menu
                    anchorEl={anchorEls.state}
                    open={Boolean(anchorEls.state)}
                    onClose={() => handleMenuClose('state')}
                    className={styles.dropdownMenu}
                    PaperProps={{ className: `${styles.menuPaper} ${styles.stateMenuPaper}` }}
                  >
                    {indianStatesAndUTs.map((state) => (
                      <MenuItem key={state} className={styles.menuItem}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isRegionChecked(MapFilters.STATE, state)}
                              onChange={() => toggleRegion(MapFilters.STATE, state)}
                              size="small"
                            />
                          }
                          label={state}
                          className={styles.checkboxLabel}
                        />
                      </MenuItem>
                    ))}
                  </Menu>
                </Box>

                <Box className={styles.mapTypeFilters}>
                  <Typography
                    className={`${styles.typeFilter} ${
                      isFilterActive(MapFilters.TYPE, 'RMPM Shortage') 
                        ? styles.activeTypeFilter 
                        : ''
                    }`}
                    onClick={() => toggleFilter(MapFilters.TYPE, 'RMPM Shortage')}
                  >
                    RMPM Shortage
                  </Typography>
                  <Divider
                    orientation="vertical"
                    flexItem
                    className={styles.verticalSeparator}
                  />
                  <Typography
                    className={`${styles.typeFilter} ${
                      isFilterActive(MapFilters.TYPE, 'Manufacturing Disruption')
                        ? styles.activeTypeFilter 
                        : ''
                    }`}
                    onClick={() => toggleFilter(MapFilters.TYPE, 'Manufacturing Disruption')}
                  >
                    Manufacturing Disruption
                  </Typography>
                </Box>
              </Box>
              
              <Box className={`${styles.mapContainer} ${styles.doubleCardHeight}`}>
                <MapChart />
              </Box>
            </Box>
          </Grid>

          {/* External Disruption*/}
          <Grid item style={{
            width: "inherit"
          }}>
            <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
              <ExternalDisruption />
            </Box>
          </Grid>

          {/* Day and OLA widgets*/}
          <Grid item className={styles.gridItem}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
                  <Day0Widget /> 
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
                  <DRWidget />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Right Column */}
      <Grid item xs={12} md={3} className={styles.rightColumn}>
        <Grid container direction="column" spacing={1}>
          <Grid item className={styles.gridItem}>
            <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
              {<ProjectedORWidget />}
            </Box>
          </Grid>
          <Grid item className={styles.gridItem}>
            <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
              <DispatchComplianceWidget />
            </Box>
          </Grid>
          <Grid item className={styles.gridItem}>
            <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
              <ManpowerIndexWidget />
            </Box>
          </Grid>
          <Grid item className={styles.gridItem}>
            <Box className={`${styles.cardStyle} ${styles.standardCardHeight} ${styles.cardWithBg}`}>
              <OSAWidget />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}